import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { isAppShellPath } from "../layout/isAppShellPath";
import { setViewAsRole, useViewAsRole } from "./viewAsRoleStore";

export const ViewAsRoleScope = () => {
  const { pathname } = useLocation();
  const viewAsRole = useViewAsRole();

  useEffect(() => {
    if (viewAsRole && !isAppShellPath(pathname)) setViewAsRole(null);
  }, [pathname, viewAsRole]);

  return null;
};
